import Storage from 'storage';

import { hasUserCookie } from 'utils/cookies';

const SESSION_KEYS = ['user', 'API_ENDPOINT', 'environment'];

const hasCompleteSession = (): boolean =>
  hasUserCookie() && SESSION_KEYS.every((key) => Boolean(Storage.get(key)));

const clearSession = () => {
  SESSION_KEYS.forEach((key) => Storage.remove(key));
};

const getApiEndpoint = (): string | null => {
  const endpoint = Storage.get('API_ENDPOINT');

  if (!endpoint && Storage.get('user')) {
    clearSession();
    window.location.reload();
  }

  return endpoint;
};

const missingEndpointError = { error: 'No API endpoint' };

export {
  SESSION_KEYS,
  hasCompleteSession,
  clearSession,
  getApiEndpoint,
  missingEndpointError,
};
